var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m5.247 10.6-.793.793a.854.854 0 0 0 0 1.21l6.939 6.943a.853.853 0 0 0 1.21 0l6.943-6.942a.853.853 0 0 0 0-1.211l-.793-.793a.86.86 0 0 0-1.225.014l-4.1 4.304V4.654a.855.855 0 0 0-.857-.857H11.43a.855.855 0 0 0-.857.857v10.264l-4.1-4.303a.85.85 0 0 0-1.225-.015Z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowDown;